import type { ReactElement } from 'react';

import { AccessDenied, EmptyState, ErrorState } from '@/ui/kit';

import type { StockProblem } from './stockPresentation';

/**
 * Ce que l'ecran dit d'un echec de lecture (voir `describeStockProblem`).
 *
 * Un refus de role n'est pas une panne et ne deconnecte personne ; un constat
 * (lot sans trace, compte anonymise, journal trop volumineux) n'appelle pas
 * « Réessayer » ; seule une vraie panne le propose.
 */
export const ProblemView = ({ problem, onRetry }: { problem: StockProblem; onRetry: () => void }): ReactElement => {
  if (problem.kind === 'forbidden') {
    return (
      <AccessDenied title="Votre rôle ne permet pas cette lecture">
        Vous êtes bien connecté, mais ce compte n’a pas de rôle d’administration qui permette de consulter la
        traçabilité du stock. Un rôle s’attribue depuis le serveur, jamais depuis cet écran.
      </AccessDenied>
    );
  }

  if (problem.kind === 'notice') {
    return <EmptyState title={problem.title} description={problem.message} />;
  }

  return <ErrorState message={problem.message} onRetry={onRetry} />;
};
